import React from 'react'
import {
    renderShortMessage
} from '../utils/messages';

const GeneralMessage = (props) => {
    let message = `${props.title} ${props.comparison !== undefined ? renderShortMessage(props.percentageDaily, props.comparison, props.swapped) : ''}.`;
    if (props.title == "Purchases") {
        message = message.replace('is', 'are');
    }

    return (
        <div className="general-message">{message}</div>
    )
}

export default GeneralMessage;